module.exports = __webpack_public_path__ + "static/media/cancel-package_4.c5bc504b.png";